import { createSlice } from "@reduxjs/toolkit";

interface LibraryState {
  books: unknown[];
  loading: boolean;
  error: string | null;
}

const initialState: LibraryState = {
  books: [],
  loading: false,
  error: null,
};

const librarySlice = createSlice({
  name: "library",
  initialState,
  reducers: {
    setBooks: (state, action) => {
      state.books = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setBooks, setLoading, setError } = librarySlice.actions;
export default librarySlice.reducer;
